var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnTheWay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/On the way"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250842",
    d: "M0.705883 21.1765H23.294",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 234250843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2935 11.9974V17.6048H20.7267H15.593H13.0262V11.2327V7.1546H19.6999C19.6999 7.1546 19.9626 9.20844 20.7267 10.2132C21.464 11.1828 23.2935 11.9974 23.2935 11.9974Z",
    fill: "#BABFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0262 11.2327V7.1546H19.6999C19.6999 7.1546 19.9626 9.20844 20.7267 10.2132C21.464 11.1828 23.2935 11.9974 23.2935 11.9974V17.6048H20.7267H15.593H13.0262V11.2327ZM13.0262 11.2327H17.9031",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250846",
    d: "M0.705883 17.6068H4.81282M13.0267 7.15657H19.7005C19.7005 7.15657 19.9631 9.21041 20.7272 10.2152C21.4646 11.1848 23.294 11.9994 23.294 11.9994V17.6068H20.7272M13.0267 7.15657V2.82355H5.58287M13.0267 7.15657V11.2347M13.0267 17.6068V11.2347M13.0267 17.6068H9.9465M13.0267 17.6068H15.5935M13.0267 11.2347H17.9037",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008927"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1016",
    cx: 5.37255,
    cy: 9.60789,
    r: 4.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1017",
    d: "M7.12255 5.28044C6.58213 5.06169 5.99141 4.94122 5.37255 4.94122C2.79522 4.94122 0.705883 7.03056 0.705883 9.60789C0.705883 12.1852 2.79522 14.2746 5.37255 14.2746C7.94988 14.2746 10.0392 12.1852 10.0392 9.60789C10.0392 9.41034 10.0269 9.21565 10.0031 9.02456",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250835",
    d: "M3.52221 8.29201L5.80793 10.395L10.0528 5.8501",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1023",
    cx: 7.37942,
    cy: 18.371,
    rx: 2.56684,
    ry: 2.54884,
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1024",
    cx: 18.1609,
    cy: 18.371,
    rx: 2.56684,
    ry: 2.54884,
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTheWay);
export default __webpack_public_path__ + "static/media/On-the-way.7f4431e9cf1ab2ef2a2c85995f622bd5.svg";
export { ForwardRef as ReactComponent };